export default __webpack_public_path__ + "static/media/background_service_desktop.d76af518.png";